
import { useEffect, useState } from 'react';
import PageTitle from '../../../components/Accessibility/PageTitle';
import './styles.css';
import { aceiteAltaPaciente, getTermoAltaCronicos } from '../../../services/SaudeBemEstar/GestaoDeCronicosService';
import DefaultTextBold from '../../../components/Accessibility/DefaultTextBold';
import DefaultText from '../../../components/Accessibility/DefaultText';
import { CircularProgress } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import DefaultCheckbox from '../../../components/Accessibility/DefaultCheckbox';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import { useController } from './useController';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { useParams } from 'react-router-dom';

const TermosUso: React.FC = () => {

  const [content, setContent] = useState<string>('');
  const [idTermo, setIdTermo] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [agreed, setAgreed] = useState<boolean>(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);

	const { goToConclusao } = useController();
  const { idComunic } = useParams();

  useEffect(() => {
    setLoading(true);
    getTermoAltaCronicos()
      .then(response => {
        setContent(response?.data.descricao);
        setIdTermo(response?.data.idTermoResponsabilidade);
      })
      .catch(error => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setLoading(false);
      })
  }, []);

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAgreed(event.target.checked);
};

  const { 
    fontSizeStyleAccessibility, 
    contrastStyle, 
    contrastMode,
    contrastBorderAccessibility } = useAccessibility();

	const handleAceitar = () => {
    if (idComunic) {
      aceiteAltaPaciente(idTermo, idComunic)
        .then(response => {
          console.log(response);
          goToConclusao();
        })
    }
	}

  return (
    <>
      <div className='encerramento-page-container'>
        <PageTitle text='Parabéns!' />
        <DefaultTextBold text="Você recebeu alta do programa!" />
        <DefaultText text="Leia atentamente os termos de alta para prosseguir:" />

        {
          loading
          ? <CircularProgress />
          : <>
              <div className='termos-de-uso-encerramento-container' style={{ ...contrastStyle, ...contrastBorderAccessibility}}>
                <div 
                  className={`termos-de-uso-encerramento-descricao ${contrastMode ? 'contrast' : ''}`}
                  style={fontSizeStyleAccessibility} 
                  dangerouslySetInnerHTML={{ __html: content }}
                  tabIndex={0} />
              </div>
              <div className='flex-row'>
                <DefaultCheckbox onChange={handleCheck}/>
                <DefaultText text="Eu li e concordo com os Termos de Uso da Gestão de Crônicos" />
				      </div>

				      <DefaultButton disabled={!agreed} text='Confirmar' onClick={handleAceitar} />
            </> 
      	}

        <ModalFeedBack
          showModal={showErrorModal}
          handleShowModal={() => setShowErrorModal(false)}
          title="Ocorreu um erro"
          subTitle="Falha ao buscar informações. Tente novamente mais tarde."
          icon="error"
          showButtonModal
          textButton="Fechar"
          handleButtonModal={() => setShowErrorModal(false)}
      />  
      
				
      </div>
    </>
  )
}

export default TermosUso;